import { render, staticRenderFns } from "./VGrid.vue?vue&type=template&id=7ef3ba7c&scoped=true&"
import script from "./VGrid.vue?vue&type=script&lang=js&"
export * from "./VGrid.vue?vue&type=script&lang=js&"
import style0 from "./VGrid.vue?vue&type=style&index=0&id=7ef3ba7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef3ba7c",
  null
  
)

export default component.exports